import { interpolateTemplate } from '../lib/i18n/dictionary';

interface ShareGallery {
  title: string;
  link?: string | null;
  passwordEnabled: boolean;
  password?: string | null;
}

// Localized templates: `link` takes {title} and {link}, `password` takes {password}.
export interface ShareTextTemplates {
  link: string;
  password: string;
}

// The message the Provider sends the client: title and link, then the password when it is on.
export function buildClientShareText(gallery: ShareGallery, templates: ShareTextTemplates): string {
  const link = gallery.link?.trim() ?? '';
  const title = gallery.title.trim();
  const lines = [title ? interpolateTemplate(templates.link, { title, link }) : link];
  if (gallery.passwordEnabled && gallery.password) {
    lines.push(interpolateTemplate(templates.password, { password: gallery.password }));
  }
  return lines.join('\n');
}

// "Copy file names": comma-separated, ready to paste into a Lightroom / Capture One search.
export function buildFileNamesText(fileNames: string[]): string {
  const names = fileNames.map((name) => name.trim()).filter(Boolean);
  return Array.from(new Set(names)).join(', ');
}
